module.exports = __webpack_public_path__ + "img/1940-Lonnie-Smith-cropped.a29a337a.jpg";